// extracted by mini-css-extract-plugin
export default {"outerwrap":"StudyTopicsTool_outerwrap__Ka74T","add-quest-wrap":"StudyTopicsTool_add-quest-wrap__mGjqC","list-item-delete":"StudyTopicsTool_list-item-delete__eDi0X"};